import { getAuthProviderFetchJson } from './Auth';
import { appServer, superAdminApiServer } from './config';

export interface LoginAsToken {
  email: string;
  token: string;
}

/** Who to log in as: a profile, or a user account on the profile it has selected. */
export type LoginAsTarget = { profileUuid: string } | { userAccountId: string | number };

/** Asks superadmin-server for a fresh single-use token: the client admin refuses a used or expired one. */
export const mintLoginAsToken = async (target: LoginAsTarget): Promise<LoginAsToken> => {
  const path = 'profileUuid' in target ? `profiles/${encodeURIComponent(target.profileUuid)}` : `user-accounts/${encodeURIComponent(String(target.userAccountId))}`;
  const { json } = await getAuthProviderFetchJson(`${superAdminApiServer}/admin/login-as/${path}`, { method: 'POST' });
  if (!json || typeof json.email !== 'string' || typeof json.token !== 'string' || !json.email || !json.token) throw new Error('Unexpected login-as response shape');
  return { email: json.email, token: json.token };
};

// Encoded: an e-mail with "+" would otherwise reach the client admin with a space.
export const loginAsUrl = ({ email, token }: LoginAsToken, systemAdminUuid?: string): string => {
  const params = new URLSearchParams({ authEmail: email, authToken: token });
  if (systemAdminUuid) params.set('systemAdminUuid', systemAdminUuid);
  return `${appServer}/?${params.toString()}`;
};
